export interface LifeState {
  lives: number;
  invulnerableUntilMs: number;
}

export function createLifeState(lives: number): LifeState {
  return { lives, invulnerableUntilMs: -1 };
}

export function isInvulnerable(state: LifeState, elapsedMs: number): boolean {
  return elapsedMs < state.invulnerableUntilMs;
}

export interface HitResult {
  applied: boolean;
  lives: number;
  gameOver: boolean;
  invulnerableUntilMs: number;
}

export function applyHazardHit(
  state: LifeState,
  elapsedMs: number,
  invulnerabilityMs: number,
): HitResult {
  if (state.lives <= 0) {
    return {
      applied: false,
      lives: 0,
      gameOver: true,
      invulnerableUntilMs: state.invulnerableUntilMs,
    };
  }
  if (isInvulnerable(state, elapsedMs)) {
    return {
      applied: false,
      lives: state.lives,
      gameOver: false,
      invulnerableUntilMs: state.invulnerableUntilMs,
    };
  }

  const lives = state.lives - 1;
  return {
    applied: true,
    lives,
    gameOver: lives <= 0,
    invulnerableUntilMs: elapsedMs + invulnerabilityMs,
  };
}
